export default "__VITE_ASSET__Djhc7SFr__"